module.exports = require("lodash/invoke");


//////////////////
// WEBPACK FOOTER
// external "lodash/invoke"
// module id = 66
// module chunks = 0